import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import {
  trackCheckInThirdPartyAuthSuccess,
  trackCheckInThirdPartyAuthError,
} from '../../../analytics';

import { Button } from '../../../components/general';
import { ErrorModal } from '../../../components/modals';

import { URL } from '../../../constants';

import PageSpinner from '../../../pages/General/pageSpinner';

import { getLinkedInUserInfo } from '../../../services/api/linkedin';

import { useAttendeeStore } from '../../../stores/attendee';

import { ModalError } from '../../../types';
import {
  getUrl,
  getCheckInRedirectUri,
  get3rdPartyRedirectUri,
} from '../../../utils';

const LinkedInCallback = () => {
  const didMount = useRef(false);

  const [searchParams] = useSearchParams();
  const purpose = searchParams.get('purpose');
  const code = searchParams.get('code') ?? '';
  const eventId = searchParams.get('state') ?? '';

  const { setAttendeeDetails } = useAttendeeStore();

  const [error, setError] = useState<ModalError>(null);

  const navigate = useNavigate();

  useEffect(() => {
    const onMount = async () => {
      if (didMount.current) return;

      didMount.current = true;

      switch (purpose) {
        case 'check-in':
          try {
            const { userInfo } = await getLinkedInUserInfo(
              code,
              get3rdPartyRedirectUri('linkedin', purpose),
            );

            setAttendeeDetails({
              attendeeEmail: userInfo.email,
              attendeeName: userInfo.name,
            });

            trackCheckInThirdPartyAuthSuccess('linkedin');

            navigate(getCheckInRedirectUri(eventId));
          } catch (err: any) {
            trackCheckInThirdPartyAuthError('linkedin', err);

            setError({
              subheading:
                "We couldn't authenticate you with LinkedIn. Please try again later",
              onClick: () => navigate(getUrl(URL.CHECK_IN, eventId)),
            });
          }

          break;

        default:
          break;
      }
    };

    onMount();
  }, [code, eventId, navigate, purpose, setAttendeeDetails]);

  if (!!error)
    return (
      <ErrorModal
        show={!!error}
        heading="Something went wrong"
        subheading={error?.subheading}
        btn={
          <Button className="w-full" onClick={error?.onClick}>
            Try Again
          </Button>
        }
        isContactUs
      />
    );

  return <PageSpinner isFullPage noTips />;
};

export default LinkedInCallback;
